module.exports = __webpack_public_path__ + "img/ft-img.637ecc39.jpeg";